import { render, staticRenderFns } from "./SolicitacaoRespostaLista.vue?vue&type=template&id=3282b703"
import script from "./SolicitacaoRespostaLista.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRespostaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports